// extracted by mini-css-extract-plugin
module.exports = {"root":"BackImages_root__2380d","title":"BackImages_title__2p9zW","images":"BackImages_images__2VimX"};